import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './content.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

export const ContentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const contentEntity = useAppSelector(state => state.content.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="contentDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.content.detail.title">Content</Translate>
        </h2>
        {contentEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {contentEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.code" />
          </FieldLabel>
          <FieldValue>{contentEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.title" />
          </FieldLabel>
          <FieldValue>{contentEntity.title}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.shortDescription" />
          </FieldLabel>
          <FieldValue>{contentEntity.shortDescription}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.data" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{contentEntity.data}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.meta" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{contentEntity.meta}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.createdDate" />
          </FieldLabel>
          <FieldValue>
            {contentEntity.createdDate ? <TextFormat value={contentEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} /> : null}
          </FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.language" />
          </FieldLabel>
          <FieldValue>{contentEntity.language ? contentEntity.language.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.createdBy" />
          </FieldLabel>
          <FieldValue>{contentEntity.createdBy ? contentEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.destination" />
          </FieldLabel>
          <FieldValue>{contentEntity.destination ? contentEntity.destination.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.tourCategory" />
          </FieldLabel>
          <FieldValue>{contentEntity.tourCategory ? contentEntity.tourCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.place" />
          </FieldLabel>
          <FieldValue>{contentEntity.place ? contentEntity.place.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.placeCategory" />
          </FieldLabel>
          <FieldValue>{contentEntity.placeCategory ? contentEntity.placeCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.tourExtraCategory" />
          </FieldLabel>
          <FieldValue>{contentEntity.tourExtraCategory ? contentEntity.tourExtraCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.tourExtra" />
          </FieldLabel>
          <FieldValue>{contentEntity.tourExtra ? contentEntity.tourExtra.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.menu" />
          </FieldLabel>
          <FieldValue>{contentEntity.menu ? contentEntity.menu.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.webPage" />
          </FieldLabel>
          <FieldValue>{contentEntity.webPage ? contentEntity.webPage.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.tag" />
          </FieldLabel>
          <FieldValue>{contentEntity.tag ? contentEntity.tag.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.tourStep" />
          </FieldLabel>
          <FieldValue>{contentEntity.tourStep ? contentEntity.tourStep.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.promotion" />
          </FieldLabel>
          <FieldValue>{contentEntity.promotion ? contentEntity.promotion.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.content.imageFile" />
          </FieldLabel>
          <FieldValue>{contentEntity.imageFile ? contentEntity.imageFile.code : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/content"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/content/${contentEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContentDetail;
